import React, { useContext, useEffect, useState } from 'react'
import {Avatar, IconButton} from '@material-ui/core'
import ChatIcon from '@material-ui/icons/Chat'
import DonutLargeIcon from "@material-ui/icons/DonutLarge"
import MoreVertIcon from "@material-ui/icons/MoreVert" 
import {SearchOutlined} from "@material-ui/icons"
import SidebarChat from './SidebarChat'
import db from './firebase'
import './Sidebar.css'
import { AppContext } from './App'

export default function Sidebar() {
    const [rooms, setRooms] = useState([]);   
    const context = useContext(AppContext);
    useEffect(()=>{
        // console.log(context);
        const unsubscribe =  db.collection('rooms').onSnapshot(snapshot => {
            setRooms(
                snapshot.docs.map(doc => ({
                    id: doc.id, 
                    data: doc.data(),
                }))
            )
        });
        return ()=>{
            unsubscribe(); 
        }
    }, [])
    return (
        <div className="sidebar">
            <div className="sidebar__header">
                <Avatar src={context.user.get.user.photoURL} />
                <div className="sidebar__headerRight">
                    <IconButton>
                        <DonutLargeIcon/>
                    </IconButton>
                    <IconButton>
                        <ChatIcon/>
                    </IconButton>
                    <IconButton>
                        <MoreVertIcon/>
                    </IconButton>
                </div>
            </div>
            {/* searchbar */}
            <div className="sidebar__search">
                <div className="sidebar__searchContainer">
                    <SearchOutlined />
                    <input placeholder="Search or start new chat" type="text"/>
                </div>
            </div>
            {/* sidebar chats section */}
            <div className="sidebar__chats">
                <SidebarChat addNewChat={true}/>
                {rooms.map(room => (
                    <SidebarChat key={room.id} id={room.id} name={room.data.name} addNewChat={false}/>
                ))}
                
            </div>
        </div>
    )
}
 